import SidebarToggleStyled from './styled/SidebarToggleStyled'
import { palette, ChevronNext, ChevronPrev } from '@busie/ui-kit'

interface Props {
  isOpen: boolean
  onToggle: () => void
}

const SidebarToggle: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  onToggle,
}) => {
  const Icon = isOpen ? ChevronPrev : ChevronNext

  return (
    <SidebarToggleStyled onClick={onToggle} isOpen={isOpen}>
      <Icon color={palette.black.main} />
    </SidebarToggleStyled>
  )
}

export default SidebarToggle
